/***********************
 * REACT EMAIL RELEASE NOTE
 ************************/

import React from "react"
import {
  Body,
  Container,
  Head,
  Html,
  Img,
  Preview,
  Section,
  Text,
  Row,
  Column,
  Link,
} from "@react-email/components"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

// IMG must be public not local
const baseUrl = `https://app.suvanto.care`

// Preview values
const previewValues = {
  releaseNotes: {
    target: "ReleaseNoteTypes." + 5,
    type: "Update",
    version: "2.0.7",
    informed_date: "04.06.2025",
    release_date: "04.06.2025",
    what_changes_fi: "TODO",
    how_use_changes_fi: "TODO",
    how_effects_fi: "TODO",
    changes_enduser_ui: "Yes",
    changes_pro_ui: "Yes",
    changes_user_methods: "Yes",
    updated: "04.06.2025",
  },
}

const ReleaseNoteEmail = props => {
  return (
    <Html lang="en">
      <Head>
        {/* <Font
          fontFamily="Poppins"
          fallbackFontFamily="Arial, sans-serif"
          webFont={{
            url: "https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap",
            format: "woff2",
          }}
          fontWeight="400"
          fontStyle="normal"
        /> */}
      </Head>
      <Body style={main}>
        <Preview>{props.t("Release note")}</Preview>
        <Container style={container}>
          <Section style={card}>
            <Row>
              <Column style={topLeft}>
                <Text style={title}>{props.t("Release note")}</Text>
                <Text style={date}>
                  {props.releaseNotes?.informed_date ??
                    previewValues.releaseNotes.informed_date}
                </Text>
                {props.releaseNotes?.updated ? (
                  <Text style={update}>
                    {props.t("Updated") + " " + props.releaseNotes.updated}
                  </Text>
                ) : (
                  <Text>
                    {props.t("Updated") +
                      " " +
                      previewValues.releaseNotes.updated}
                  </Text>
                )}
              </Column>
              <Column style={topRight}>
                <Img
                  src={`${baseUrl}/logo_suvanto_pyorea.png`}
                  alt="Suvanto Care"
                  style={img}
                />
              </Column>
            </Row>

            <Text style={subtitle}>
              {props.releaseNotes?.target ?? previewValues.releaseNotes.target}
            </Text>

            <Text style={version}>
              {props.releaseNotes?.type ?? previewValues.releaseNotes.type}
              {" v."}
              {props.releaseNotes?.version ??
                previewValues.releaseNotes.version}
            </Text>

            <Text style={sectionHeading}>{props.t("Changes")}</Text>
            {(
              props.releaseNotes?.what_changes_fi ??
              previewValues.releaseNotes.what_changes_fi
            )
              .split("\n")
              .filter(line => line.trim())
              .map((line, i) => (
                <Text key={""+i} style={bodyText}>
                  {line}
                </Text>
              ))}

            <Text style={sectionHeading}>{props.t("Visible in")}</Text>
            <Section style={{ marginTop: 17, marginBottom: 30 }}>
              {(
                props.releaseNotes?.how_use_changes_fi ??
                previewValues.releaseNotes.how_use_changes_fi
              )
                .split("\n")
                .filter(line => line.trim())
                .map((line, i) => (
                  <Text key={""+i} style={bodyTextList}>
                    {line}
                  </Text>
                ))}
            </Section>

            <Text style={sectionHeading}>{props.t("Affects")}</Text>
            <table role="presentation" style={table}>
              <tbody>
                <tr>
                  <td style={tdLeft}>
                    {props.t("User interface for end user")}
                  </td>
                  <td style={tdRight}>
                    {props.releaseNotes?.changes_enduser_ui ??
                      previewValues.releaseNotes.changes_enduser_ui}
                  </td>
                </tr>
                <tr>
                  <td style={tdLeft}>
                    {props.t("User interface for professional user")}
                  </td>
                  <td style={tdRight}>
                    {props.releaseNotes?.changes_pro_ui ??
                      previewValues.releaseNotes.changes_pro_ui}
                  </td>
                </tr>
                <tr>
                  <td style={tdLeft}>{props.t("Procedural changes")}</td>
                  <td style={tdRight}>
                    {props.releaseNotes?.changes_user_methods ??
                      previewValues.releaseNotes.changes_user_methods}
                  </td>
                </tr>
              </tbody>
            </table>

            <Text style={bodyText}>
              {props.releaseNotes?.how_effects_fi ??
                previewValues.releaseNotes.how_effects_fi}
            </Text>

            <Text style={sectionHeading}>{props.t("Release date")}</Text>
            <Text style={bodyText}>
              {props.releaseNotes?.release_date ??
                previewValues.releaseNotes.release_date}
            </Text>
          </Section>
        </Container>
        <Link
          href="https://www.suvantocare.fi/"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "none" }}
        >
          <Text style={footer}>© {new Date().getFullYear()} Suvanto Care</Text>
        </Link>
      </Body>
    </Html>
  )
}

ReleaseNoteEmail.propTypes = {
  t: PropTypes.any,
  releaseNotes: PropTypes.any,
}

// Styles
const main = {
  backgroundColor: "#f5f5f5",
  // fontFamily: "'Poppins', Arial, sans-serif",
  fontFamily: "Arial, sans-serif",
  padding: "20px 0",
}
const topLeft = {
  width: "50%",
}
const topRight = {
  textAlign: "right",
  width: "50%",
}

const container = {
  maxWidth: "600px",
  margin: "0 auto",
  padding: "30px 30px 30px 30px",
}

const card = {
  backgroundColor: "#ffffff",
  border: "1px solid rgb(235, 234, 234)",
  borderRadius: "5px",
  padding: "30px 40px 30px 40px",
}

const img = {
  display: "inline-block",
  height: "50px",
  width: "auto",
  paddingRight: "30px",
  paddingTop: "0px",
}

const title = {
  fontSize: "22px",
  fontWeight: "500",
  color: "#00a0d6",
  marginBottom: "5px",
}

const date = {
  fontSize: "14px",
  color: "#888888",
  fontWeight: "600",
  marginBottom: "0px",
  marginTop: "0px",
}

const update = {
  color: "#888888",
  fontSize: "13px",
  marginTop: "0",
}
const subtitle = {
  fontSize: "16px",
  fontWeight: "600",
  marginBottom: "2px",
  color: "#495057",
}

const version = {
  fontSize: "14px",
  color: "#555555",
  marginBottom: "16px",
}

const sectionHeading = {
  fontSize: "15px",
  fontWeight: "600",
  marginTop: "20px",
  marginBottom: "8px",
  color: "#495057",
}

const bodyText = {
  fontSize: "14px",
  lineHeight: "1.5",
  marginTop: 0,
}
const bodyTextList = {
  fontSize: "14px",
  lineHeight: "0.2",
  marginTop: 0,
}

const table = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: 0,
  margin: "8px 0 24px",
}

const tdLeft = {
  fontSize: "14px",
  padding: "8px 0",
  borderBottom: "1px solid #e0e0e0",
}

const tdRight = {
  fontSize: "14px",
  padding: "8px 0",
  borderBottom: "1px solid #e0e0e0",
  textAlign: "right",
}

const footer = {
  fontSize: "12px",
  color: "#00a0d6",
  textAlign: "center",
  marginTop: "32px",
}

export default withTranslation()(ReleaseNoteEmail)
